export default __webpack_public_path__ + "static/media/home_industarial.d6823db1.jpg";